import React from 'react'
import ImageComponent from './image'
const SectionSponsorComponent = props =>
    <div className="section--secondary u-text-center" id="sponsor">
        <small>Sponsored by</small>
        <div className="c-grid--sponsors">
        <a href="http://www.regione.sicilia.it/beniculturali/sopripa/" target="_blank" alt="Soprintendenza di Palermo"><ImageComponent image="sop" /></a>
        <a href="https://www.sheffield.ac.uk" target="_blank" alt="University of Sheffield"><ImageComponent image="sheff" /></a>
        <a href="https://ludwig.guru" target="_blank" alt="Ludwig"><ImageComponent image="lud" /></a>
        <a href="https://www.alexandriaarchive.org/icaz/" target="_blank" alt="Icaz - International Council for Archaeology"><ImageComponent image="icaz" /></a>
        <a href="http://www.aiaz.it/" target="_blank" alt="Aiaz - Associazione Italiana Archeologia"><ImageComponent image="aiaz" /></a>
        <a href="https://www.barpublishing.com/" target="_blank" alt="BAR - Publishing"><ImageComponent image="bar" /></a>
        <a href="https://www.oxbowbooks.com/" target="_blank" alt="Oxbooks"><ImageComponent image="ox" /></a>
        </div>
    </div>

export default SectionSponsorComponent



// WEBPACK FOOTER //
// ./src/components/section-sponsor.js